import { render, staticRenderFns } from "./comp-card.vue?vue&type=template&id=4026e348&scoped=true"
import script from "./comp-card.vue?vue&type=script&lang=js"
export * from "./comp-card.vue?vue&type=script&lang=js"
import style0 from "./comp-card.vue?vue&type=style&index=0&id=4026e348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4026e348",
  null
  
)

export default component.exports